module.exports = __webpack_public_path__ + "media/C7.c2561d5f.wav";